import React, { forwardRef } from "react";
import FormField from "@components/FormField";
import InputField from "@components/InputField";

function FormikInput({ label, error, field, ...props }, ref) {
  return (
    <FormField label={label} id={props.name} errorMsg={error}>
      <InputField
        {...props}
        {...field}
        ref={ref}
        errorMsg={error}
        data-testid={`${props.name}-input`}
      />
    </FormField>
  );
}

export default forwardRef(FormikInput);
